import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { breakpoints } from "../../../theme"

const Grid = ({ columns, children, smallGap }) => {
  const Wrapper = Columns[columns]
  return <Wrapper smallGap={smallGap}>{children}</Wrapper>
}

Grid.propTypes = {
  columns: PropTypes.oneOf([2, 3, 4]),
}

Grid.defaultProps = {
  columns: 2,
}

export { Grid }

const base = css`
  display: grid;
  grid-gap: 25px;

  @media (min-width: ${breakpoints.small}px) {
    grid-gap: ${props => (props.smallGap ? "15px" : "45px")};
  }

  @media (min-width: ${breakpoints.medium}px) {
    grid-gap: ${props => (props.smallGap ? "15px" : "65px")};
  }
`

const Columns = {
  2: styled.div`
    ${base}
    @media (min-width: ${breakpoints.medium}px) {
      grid-template-columns: 1fr 1fr;
    }
  `,
  3: styled.div`
    ${base}
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  `,
  4: styled.div`
    ${base}

    @media (min-width: ${breakpoints.medium}px) {
      grid-gap: 25px;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  `,
}
